"use client";

// Custom next/image loader that rewrites src to Directus transform URLs.
// Directus serves optimized bytes directly — no Next.js runtime optimization.
//
// Input src is the full asset URL (e.g. https://admin.autobook.lt/assets/<uuid>),
// optionally carrying a `?v=<ts>` cache-bust token. We rebuild the query as
// ?width=<w>&quality=<q>&format=webp, preserving `v` so replaced photos get a
// fresh URL (Directus ignores `v` for the transform, so it shares one cache entry).

export default function directusLoader({
  src,
  width,
  quality,
}: {
  src: string;
  width: number;
  quality?: number;
}): string {
  const [base, query = ""] = src.split("?");
  const v = new URLSearchParams(query).get("v");
  const q = quality ?? 75;
  let url = `${base}?width=${width}&quality=${q}&format=webp`;
  if (v) url += `&v=${v}`;
  return url;
}
